<template>
  <a-result status="success"
            :title="$Enum.TextEnum.SuccessLogout" sub-title="正在返回..." />
</template>

<script lang="ts" type="text/tsx">
export default {
  name: 'logout',
  props: [
    'backSource'
  ],
  mounted(): void {
    !$Store.User().operate && $Store.User().$patch({
      operate: $Enum.OperateEnum.Logout
    });
    $RQ.SSO.logout();
    this.backSource();
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}sso/';

.ant-result {
  //display: none;
  padding: 200px 50px;
  
  &:deep(.ant-result-subtitle) {
    margin-top: 10px;
  }
}
</style>